import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { AppEnvironmentConfig } from 'projects/config/model/environment.config.model';
import { SitesService } from '@solvace/core/features/sites/services/sites.service';
import { UserService } from '@solvace/core/features/user/services/user.service';
import { MentionTeam, MentionUser, MentionHashtag } from './svc-quill-editor-mention.model';

@Injectable()
export class SvcQuillEditorMentionService {
  #appConfig = inject(AppEnvironmentConfig);
  #http = inject(HttpClient);
  #sitesService = inject(SitesService);
  #userService = inject(UserService);

  public get currenSiteName(): string {
    return this.#sitesService?.currentSite?.siteName ?? '';
  }

  getUsers(term: string): Observable<MentionUser[]> {
    return this.#userService
      .getUsersInfo({
        name: term,
        active: true,
        pageIndex: 1,
        pageSize: 100,
      })
      .pipe(map((response) => response?.users));
  }

  getTeams(term: string): Observable<MentionTeam[]> {
    return this.#userService
      .getTeamsInfo({
        name: term,
        active: true,
        pageIndex: 1,
        pageSize: 100,
      })
      .pipe(map((response) => response?.teams));
  }

  getHashtags(term: string): Observable<MentionHashtag[]> {
    return this.#http
      .get<{ hashtags: MentionHashtag }>(`${this.#appConfig.APIs.apiUrlHashtag}/Post/Paginated`, {
        params: {
          name: term,
          active: true,
          pageIndex: 1,
          pageSize: 100,
        },
      })
      .pipe(map((response) => <MentionHashtag[]>(response?.hashtags ?? [])));
  }
}
